class CustomSliderComponent extends HTMLElement {
  constructor() {
    super();

    this.media = this.querySelector('.u-article_media');
    this.cardReverse = this.querySelector('.u-article-card.text-content');
    this.cardBcgImage = this.querySelector('.u-article-card.bcg-image');
    this.sliderArrowBack = this.querySelector('.u-slider__arrow--back');
    this.sliderArrowForward = this.querySelector('.u-slider__arrow--forward');

    if (this.media) {
      if (!this.cardBcgImage) {
        if (this.cardReverse) {
          this.sliderArrowBack.style.bottom = this.media.offsetHeight / 2 + 'px';
          this.sliderArrowForward.style.bottom = this.media.offsetHeight / 2 + 'px';
          this.sliderArrowBack.style.top = 'auto';
          this.sliderArrowForward.style.top = 'auto';
          this.sliderArrowBack.style.transform = 'translate3d(-50%, 50%, 0)';
          this.sliderArrowForward.style.transform = 'translate3d(50%, 50%, 0)';
          this.sliderArrowBack.style.opacity = 1;
          this.sliderArrowForward.style.opacity = 1;
        } else {
          this.sliderArrowBack.style.top = this.this.media.offsetHeight / 2 + 'px';
          this.sliderArrowForward.style.top = this.this.media.offsetHeight / 2 + 'px';
          this.sliderArrowBack.style.opacity = 1;
          this.sliderArrowForward.style.opacity = 1;
        }
      } else {
        this.sliderArrowBack.style.opacity = 1;
        this.sliderArrowForward.style.opacity = 1;
      }
    } else {
      if (this.sliderArrowBack) this.sliderArrowBack.style.opacity = 1;
      if (this.sliderArrowForward) this.sliderArrowForward.style.opacity = 1;
    }


    this.slider_container = this.querySelector(".u-grid");
    this.slider_item = this.querySelector(".u-slider__item");
    if (this.slider_item) {
      this.slider_item_width = this.slider_item.offsetWidth;
    }
    this.sectionWrapper = this.closest('.shopify-section');

    // Add click handlers
    this.sectionWrapper.querySelectorAll(".u-slider__arrow--back").forEach((arrow) => {
      arrow.addEventListener("click", () => this.navigate("backward"));
    });
    this.sectionWrapper.querySelectorAll(".u-slider__arrow--forward").forEach((arrow) => {
      arrow.addEventListener("click", () => this.navigate("forward"));
    });
    // this.querySelectorAll(".slide-indicator")
    //     .forEach((dot, index) => {
    //         dot.addEventListener("click", () => navigate(index));
    //         dot.addEventListener("mouseenter", () => clearInterval(autoplay));
    //     });
    // Add keyboard handlers
    this.addEventListener("keydown", (e) => {
      if (e.code === "ArrowLeft") {
        // clearInterval(autoplay);
        this.navigate("backward");
      } else if (e.code === "ArrowRight") {
        // clearInterval(autoplay);
        this.navigate("forward");
      }
    });

    this.slider_container.addEventListener('scroll', (e) => {
      let newScrollPosition = e.target.scrollLeft;
      if (this.querySelector('.u-slider__dots')) {
        this.querySelectorAll('.u-slider__dots .active').forEach(item => {
          item.classList.remove('active');
        })
        let sliderItems = this.querySelectorAll('.u-slider__item');
        for(var k in sliderItems) {
          if (sliderItems[k].offsetLeft >= newScrollPosition) {
            this.querySelector('.u-slider__dots .u-slider__dots-item:nth-of-type('+(parseInt(k)+1)+')').classList.add('active');
            break;
          }
        }
      }

    })

    // Add resize handler
    window.addEventListener("resize", () => {
      this.slider_item_width = this.slider_item.offsetWidth;
      this.checkArrows();
    });
    this.addEventListener("slider-shown", () => {
      this.checkArrows();
    })

    this.addEventListener("click", (e) => {
      console.log(e);
      if (e.target.closest('[data-open-slide]')) {
        this.navigate(parseInt(e.target.closest('[data-open-slide]').dataset.openSlide) - 1)
      }
    });

    window.addEventListener('DOMContentLoaded', () => {
      this.checkArrows();

      if (this.closest('.grid-with-simplebar')) {
        this.style.minHeight = `${this.clientHeight + 5}px`;
        this.style.overflow = 'auto';
        this.simplebar = new SimpleBar(this, {
          autoHide: false,
        });
      }
    })
    // Autoplay
    // const autoplay = setInterval(() => navigate("forward"), 3000);
    // slideContainerEl.addEventListener("mouseenter", () => clearInterval(autoplay));
    // this.slideObserver = new IntersectionObserver((entries, observer) => {
    //     entries.forEach(entry => {
    //         if (entry.isIntersecting) {
    //             this.slider_item_index = entry.target.dataset.slideindex;
    //             this.querySelector('.slide-indicator.active').classList.remove('active');
    //             carouselEl.querySelectorAll('.slide-indicator')[slideIndex].classList.add('active');
    //         }
    //     });
    // }, { root: slideContainerEl, threshold: .1 });
    // document.querySelectorAll('.slide').forEach((slide) => {
    //     slideObserver.observe(slide);
    // });
  }
  getNewScrollPosition = (arg) => {
    const gap = +window
        .getComputedStyle(this.slider_container)
        .getPropertyValue("column-gap")
        .slice(0, 2),
      scroll_left = Math.round(this.slider_container.scrollLeft),
      slider_width = Math.round(this.slider_container.clientWidth),
      slider_scroll_width = Math.round(this.slider_container.scrollWidth),
      max_scroll_left = slider_scroll_width - slider_width;
    if (arg === "forward") {
      const x = scroll_left + slider_width;
      return x > max_scroll_left
        ? max_scroll_left - scroll_left < 5
          ? 0
          : max_scroll_left
        : x;
    } else if (arg === "backward") {
      const x = scroll_left - slider_width;
      return x < 0 ? (scroll_left == 0 ? max_scroll_left : 0) : x;
    } else if (typeof arg === "number") {
      const x = arg * (this.slider_item_width + gap);
      return x;
    }
  };
  navigate = (arg) => {
    this.slider_container.scrollLeft = this.getNewScrollPosition(arg);
  };
  checkArrows = () => {
    if (this.hasAttribute('hide-arrows-if-not-required')) {
      let grid = this.querySelector('.u-grid')
      if (this.clientWidth + 10 >= grid.children[grid.children.length - 1].offsetLeft + grid.children[grid.children.length - 1].clientWidth) {
        this.querySelectorAll('.u-slider__arrow').forEach((arrow) => arrow.style.display = 'none')
      } else {
        this.querySelectorAll('.u-slider__arrow').forEach((arrow) => arrow.style.display = 'inline-flex')
      }
    }
  }
}
customElements.define("custom-slider-component", CustomSliderComponent);
